// Adding a theme or density is config: add the value here and its `[data-theme]` /
// `[data-density]` block in themes/_design-tokens.scss.

/** What the user picked. `system` is a live subscription to the OS setting, not a snapshot. */
export type ThemeChoice = "light" | "dark" | "system";

/** What `system` resolves to, and what ends up on `<html data-theme>`. */
export type ResolvedTheme = "light" | "dark";

export type Density = "compact" | "default" | "cozy";

export const THEME_CHOICES: readonly ThemeChoice[] = ["light", "dark", "system"] as const;

export const DENSITIES: readonly Density[] = ["compact", "default", "cozy"] as const;

/**
 * No stored choice means "follow the OS", not "light". A user who has set their machine to dark
 * has already expressed the preference; making them say it again in every product is the bug.
 */
export const DEFAULT_THEME: ThemeChoice = "system";

export const DEFAULT_DENSITY: Density = "default";

export const THEME_STORAGE_KEY = "recolearn.theme";
export const DENSITY_STORAGE_KEY = "recolearn.density";

export const DARK_SCHEME_QUERY = "(prefers-color-scheme: dark)";

export function isThemeChoice(value: string | null): value is ThemeChoice {
  return value !== null && THEME_CHOICES.some((c) => c === value);
}

export function isDensity(value: string | null): value is Density {
  return value !== null && DENSITIES.some((d) => d === value);
}
